import { api, throwApiError } from "../../api/api";

export type GetFreelancerRatingsParams = {
  page?: number;
  limit?: number;
  nome?: string;
};

export type FreelancerRatingsRow = {
  freelancerId: string;
  storeNames: string[];
  fullName: string;
  contato: string | null;
  cpf: string;
  stars: number | null;
};

export type FreelancerRatingsPageResponse = {
  page: number;
  limit: number;
  totalItens: number;
  items: FreelancerRatingsRow[];
};

export const getFreelancerRatingsApi = async (
  token: string,
  params: GetFreelancerRatingsParams = {}
): Promise<FreelancerRatingsPageResponse> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;

  try {
    const { data } = await api.get<FreelancerRatingsPageResponse>("/freelancer-ratings", {
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 10,
        ...(params.nome?.trim() ? { nome: params.nome.trim() } : {}),
      },
      headers: { Authorization: `Bearer ${rawToken}` },
    });

    return data;
  } catch (error) {
    throwApiError(error, "Erro ao buscar tabela de freelancers.");
    throw error;
  }
};
